import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ── Bfcache + deployment freshness ───────────────────────────────────────────
// On bfcache restore (user switches away and back), check if index.html's ETag
// changed (i.e. a new deployment happened). If so, set a flag that Index.tsx
// will act on when the user naturally lands back on the home page — avoiding
// any mid-form interruption.
declare global {
  interface Window { __needsAppReload?: boolean; }
}

let knownEtag: string | null = null;

async function fetchEtag(): Promise<string | null> {
  try {
    const r = await fetch('/index.html', { method: 'HEAD', cache: 'no-store' });
    return r.headers.get('etag');
  } catch {
    return null;
  }
}

// Capture ETag at startup
fetchEtag().then(e => { knownEtag = e; });

window.addEventListener('pageshow', (e) => {
  if (!e.persisted) return; // not a bfcache restore, nothing to do
  fetchEtag().then(newEtag => {
    if (knownEtag && newEtag && knownEtag !== newEtag) {
      window.__needsAppReload = true;
    }
  });
});

createRoot(document.getElementById("root")!).render(<App />);

// Prefetch the four main tab chunks after the app has painted so first taps
// on Insights / Milestones / Activities feel instant.
requestIdleCallback(() => {
  import('./pages/Insights');
  import('./pages/Milestones');
  import('./pages/Activities');
  import('./pages/History');
}, { timeout: 3000 });
